<template>
  <div
    id="header"
    class="header container-fluid"
    :class="[
      { 'header__scrolled' : isScrolled},
      { 'header__opened' : isDropdownShown},
      { 'header__clear' : isClear}
      ]"
    v-click-outside="hideDropdownMenu"
  >
    <ServiceOffline v-if="showOfflineBlock" />
    <div class="main-menu container">
      <nav class="row">

        <!-- logo button -->
        <div class="col-auto">
          <router-link 
            :to="{ name: 'main' }"
          >
            <img 
              class="icon-logo"
              :src="require(`../assets/images/svg/logo.svg`)"
            />
          </router-link>

          <div class="main-menu__logos">
            <a target="_blank" href="https://discord.gg/5HugZgxgZz">
            <svg class="icon-socials__discord" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path xmlns="http://www.w3.org/2000/svg" d="M23.1723 7.49003C21.6692 6.80036 20.0574 6.29224 18.3721 6.00122C18.3415 5.9956 18.3108 6.00964 18.295 6.03771C18.0877 6.4064 17.8581 6.88738 17.6973 7.26543C15.8847 6.99407 14.0814 6.99407 12.306 7.26543C12.1452 6.87898 11.9072 6.4064 11.699 6.03771C11.6832 6.01058 11.6525 5.99654 11.6218 6.00122C9.9375 6.29131 8.3257 6.79943 6.8217 7.49003C6.80868 7.49564 6.79752 7.50501 6.79011 7.51717C3.73285 12.0847 2.89534 16.5399 3.30619 20.9399C3.30805 20.9614 3.32014 20.982 3.33687 20.9951C5.35396 22.4764 7.30786 23.3757 9.22548 23.9717C9.25617 23.9811 9.28869 23.9699 9.30822 23.9446C9.76183 23.3251 10.1662 22.672 10.5129 21.9851C10.5333 21.9449 10.5138 21.8971 10.472 21.8812C9.83062 21.6379 9.2199 21.3413 8.63243 21.0044C8.58597 20.9773 8.58225 20.9108 8.62499 20.879C8.74862 20.7864 8.87228 20.69 8.99032 20.5927C9.01168 20.5749 9.04144 20.5711 9.06655 20.5824C12.926 22.3444 17.1042 22.3444 20.9181 20.5824C20.9432 20.5702 20.973 20.574 20.9953 20.5917C21.1134 20.689 21.237 20.7864 21.3615 20.879C21.4043 20.9108 21.4015 20.9773 21.355 21.0044C20.7676 21.3478 20.1568 21.6379 19.5145 21.8803C19.4727 21.8962 19.4541 21.9449 19.4746 21.9851C19.8287 22.671 20.2331 23.3242 20.6783 23.9437C20.6969 23.9699 20.7304 23.9811 20.761 23.9717C22.688 23.3757 24.6418 22.4764 26.6589 20.9951C26.6766 20.982 26.6878 20.9623 26.6896 20.9408C27.1813 15.8539 25.866 11.4352 23.2029 7.5181C23.1964 7.50501 23.1853 7.49564 23.1723 7.49003ZM11.0892 18.2607C9.92727 18.2607 8.96986 17.194 8.96986 15.8839C8.96986 14.5738 9.90871 13.507 11.0892 13.507C12.279 13.507 13.2272 14.5832 13.2086 15.8839C13.2086 17.194 12.2697 18.2607 11.0892 18.2607ZM18.9252 18.2607C17.7633 18.2607 16.8059 17.194 16.8059 15.8839C16.8059 14.5738 17.7447 13.507 18.9252 13.507C20.115 13.507 21.0631 14.5832 21.0446 15.8839C21.0446 17.194 20.115 18.2607 18.9252 18.2607Z" fill="white"/>
            </svg>
          </a>
            <a target="_blank" href="https://t.me/omhms_mroilman">
            <svg class="icon-socials__telegram" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path d="M25 15C25 20.5228 20.5228 25 15 25C9.47716 25 5 20.5228 5 15C5 9.47716 9.47716 5 15 5C20.5228 5 25 9.47716 25 15ZM15.8959 12.1388C14.1618 12.8614 9.16185 14.9134 9.16185 14.9134C7.97689 15.3758 8.67049 15.8093 8.67049 15.8093C8.67049 15.8093 9.68205 16.1562 10.5491 16.4162C11.4162 16.6764 11.8786 16.3874 11.8786 16.3874C11.8786 16.3874 13.9017 15.0579 15.9537 13.6417C17.3988 12.659 17.052 13.4683 16.7052 13.8151C15.9537 14.5666 14.711 15.7515 13.6705 16.7053C13.2081 17.1099 13.4393 17.4567 13.6416 17.6301C14.23 18.128 15.6158 19.0335 16.245 19.4446C16.4194 19.5585 16.5356 19.6344 16.5607 19.6532C16.7052 19.7689 17.5144 20.2891 18.0058 20.1735C18.4971 20.0579 18.5549 19.3931 18.5549 19.3931C18.5549 19.3931 18.9306 17.0232 19.2774 14.8556C19.3417 14.43 19.4059 14.0133 19.4658 13.6248C19.6215 12.6149 19.7479 11.7952 19.7688 11.503C19.8555 10.5203 18.815 10.9249 18.815 10.9249C18.815 10.9249 16.5607 11.8498 15.8959 12.1388Z" fill="white"/>
            </svg>
          </a>
          <a target="_blank" href="https://www.instagram.com/omhms.mroilman/">
            <svg class="icon-socials__instagram" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path d="M15.0013 5C12.2855 5 11.9447 5.01187 10.8781 5.06042C9.81352 5.10916 9.08687 5.2777 8.45106 5.52499C7.79336 5.7804 7.23546 6.12205 6.67964 6.67808C6.12341 7.2339 5.78175 7.7918 5.52551 8.44928C5.2776 9.0853 5.10885 9.81216 5.06094 10.8763C5.01323 11.9429 5.00073 12.284 5.00073 14.9997C5.00073 17.7155 5.01282 18.0553 5.06115 19.1219C5.1101 20.1865 5.27864 20.9131 5.52572 21.5489C5.78134 22.2066 6.12299 22.7645 6.67902 23.3203C7.23463 23.8766 7.79253 24.2191 8.4498 24.4745C9.08604 24.7218 9.81289 24.8903 10.8772 24.939C11.9439 24.9876 12.2845 24.9995 15 24.9995C17.716 24.9995 18.0558 24.9876 19.1224 24.939C20.187 24.8903 20.9145 24.7218 21.5507 24.4745C22.2082 24.2191 22.7652 23.8766 23.3209 23.3203C23.8771 22.7645 24.2187 22.2066 24.475 21.5491C24.7208 20.9131 24.8896 20.1863 24.9396 19.1221C24.9875 18.0555 25 17.7155 25 14.9997C25 12.284 24.9875 11.9431 24.9396 10.8765C24.8896 9.81195 24.7208 9.0853 24.475 8.44949C24.2187 7.7918 23.8771 7.2339 23.3209 6.67808C22.7646 6.12184 22.2084 5.78019 21.5501 5.52499C20.9126 5.2777 20.1855 5.10916 19.121 5.06042C18.0543 5.01187 17.7148 5 14.9982 5H15.0013ZM14.1042 6.80203C14.3705 6.80162 14.6676 6.80203 15.0013 6.80203C17.6712 6.80203 17.9877 6.81162 19.042 6.85953C20.017 6.90411 20.5461 7.06703 20.8986 7.2039C21.3653 7.38514 21.698 7.6018 22.0478 7.95179C22.3978 8.30178 22.6144 8.63511 22.7961 9.10176C22.933 9.45384 23.0961 9.98299 23.1404 10.958C23.1884 12.0121 23.1988 12.3288 23.1988 14.9974C23.1988 17.6661 23.1884 17.9828 23.1404 19.0369C23.0959 20.0119 22.933 20.541 22.7961 20.8931C22.6148 21.3598 22.3978 21.692 22.0478 22.0418C21.6978 22.3918 21.3655 22.6085 20.8986 22.7897C20.5466 22.9272 20.017 23.0897 19.042 23.1343C17.9879 23.1822 17.6712 23.1926 15.0013 23.1926C12.3312 23.1926 12.0147 23.1822 10.9606 23.1343C9.9856 23.0893 9.45644 22.9264 9.10375 22.7895C8.63709 22.6083 8.30377 22.3916 7.95378 22.0416C7.60379 21.6916 7.38713 21.3591 7.20546 20.8923C7.06859 20.5402 6.90547 20.011 6.8611 19.0361C6.81318 17.9819 6.8036 17.6653 6.8036 14.9949C6.8036 12.3246 6.81318 12.0096 6.8611 10.9555C6.90568 9.98049 7.06859 9.45134 7.20546 9.09885C7.38671 8.63219 7.60379 8.29887 7.95378 7.94888C8.30377 7.59889 8.63709 7.38223 9.10375 7.20056C9.45624 7.06307 9.9856 6.90057 10.9606 6.85578C11.883 6.81412 12.2405 6.80162 14.1042 6.79953V6.80203ZM20.3391 8.46241C19.6766 8.46241 19.1391 8.99927 19.1391 9.66196C19.1391 10.3244 19.6766 10.8619 20.3391 10.8619C21.0015 10.8619 21.539 10.3244 21.539 9.66196C21.539 8.99947 21.0015 8.46199 20.3391 8.46199V8.46241ZM15.0013 9.86445C12.1653 9.86445 9.86602 12.1638 9.86602 14.9997C9.86602 17.8357 12.1653 20.134 15.0013 20.134C17.8373 20.134 20.1357 17.8357 20.1357 14.9997C20.1357 12.1638 17.837 9.86445 15.0011 9.86445H15.0013ZM15.0013 11.6665C16.8421 11.6665 18.3345 13.1587 18.3345 14.9997C18.3345 16.8405 16.8421 18.333 15.0013 18.333C13.1603 18.333 11.6681 16.8405 11.6681 14.9997C11.6681 13.1587 13.1603 11.6665 15.0013 11.6665V11.6665Z" fill="white"/>
            <defs>
              <radialGradient id="igcolor" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.3131 26.5398) rotate(-90) scale(19.8209 18.4348)">
              <stop stop-color="#FFDD55"/>
              <stop offset="0.1" stop-color="#FFDD55"/>
              <stop offset="0.5" stop-color="#FF543E"/>
              <stop offset="1" stop-color="#C837AB"/>
              </radialGradient>
            </defs>
            </svg>
          </a>
          <a target="_blank" href="https://youtube.com/channel/UCj3cuVAttxJp9jCtx0mjMsA">
            <svg class="icon-socials__youtube" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M25.7315 7.2749C26.1031 7.66104 26.367 8.1392 26.4966 8.66106C26.8427 10.5949 27.0106 12.5569 26.9984 14.522C27.0053 16.4577 26.8373 18.39 26.4966 20.295C26.367 20.8168 26.1031 21.295 25.7315 21.6811C25.36 22.0673 24.8939 22.3477 24.3804 22.4942C22.5041 23 14.999 23 14.999 23C14.999 23 7.49396 23 5.61769 22.4942C5.11461 22.3554 4.65554 22.0882 4.28483 21.7184C3.91412 21.3485 3.6443 20.8886 3.50144 20.3829C3.15539 18.449 2.98741 16.487 2.99965 14.522C2.99009 12.5716 3.15805 10.6245 3.50144 8.70505C3.63102 8.18318 3.89493 7.70503 4.2665 7.31888C4.63808 6.93274 5.10417 6.65227 5.61769 6.50582C7.49396 6 14.999 6 14.999 6C14.999 6 22.5041 6 24.3804 6.46184C24.8939 6.60829 25.36 6.88875 25.7315 7.2749ZM18.8169 14.522L12.5445 18.1177V10.9262L18.8169 14.522Z" fill="white"/>
            </svg>
          </a>
          </div>

        </div>

        <!-- main navigation -->
        <div class="col main-menu__items">
          <template 
            v-for="(link, index) in filteredLinks"
            :key="index"
          >
            <template v-if="link.dropdown">
                <div 
                  class="main-menu__item dropdown-toggle" 
                  id="dropdownMenuButton" 
                  data-bs-toggle="dropdown" 
                  aria-expanded=" false"
                >
                  <span> {{ link.title }} </span>
                </div>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <template
                    v-for="(linkItem, index) in link.dropdown"
                    :key="index"
                  >
                    <router-link
                      v-if="linkItem.to"
                      :to="{ name: linkItem.to, params: linkItem.params }"
                      class="main-menu__item dropdown-item"
                    >
                      <span> {{ linkItem.title }} </span>
                      <SvgIcon v-if="linkItem.icon" :icon="linkItem.icon"/>
                    </router-link>
                    <a
                      v-else-if="linkItem.href"
                      :href="`${linkItem.href}`"
                      target="_blank"
                      class="main-menu__item dropdown-item"
                    >
                      <span> {{ linkItem.title }} </span>
                      <SvgIcon v-if="linkItem.icon" :icon="linkItem.icon"/>
                    </a>
                  </template>
                </div>
            </template>
            <template v-else>
              <router-link
                v-if="link.to"
                :to="{ name: link.to, params: link.params }"
                class="main-menu__item"
              >
                <span> {{ link.title }} </span>
                <SvgIcon v-if="link.icon" :icon="link.icon"/>
              </router-link>
              <a
                v-else-if="link.href"
                :href="`${link.href}`"
                target="_blank"
                class="main-menu__item"
              >
                <span> {{ link.title }} </span>
                <SvgIcon v-if="link.icon" :icon="link.icon"/>
              </a>
            </template>
            
          </template>

          <!-- profile button: -->
          <router-link
            :to="{ name: 'profile' }"
            class="main-menu__item"
          >
            <span> Профіль </span>
          </router-link>
          <div
            class="main-menu__item main-menu__menu-toggle"
            @click.prevent="showDropdownMenu(!isDropdownShown)"
          >
            <!-- <span>Меню</span> -->
            <SvgIcon :icon="`${isDropdownShown ? 'cross' : 'menu'}`"/>
          </div>
        </div>
      </nav>
    </div>

    <MainMenuDropdown
      :shown="isDropdownShown"
      :links="filteredLinks"
      @item-click="hideDropdownMenu"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import vClickOutside from 'click-outside-vue3'

import SvgIcon from "@/components/SvgIcon"
import MainMenuDropdown from "@/components/MainMenuDropdown"
import ServiceOffline from '@/components/ServiceOffline'

import { ifUrlExist } from '@/helpers'

export default {
  name: 'Header',
  components: {
    SvgIcon,
    MainMenuDropdown,
    ServiceOffline,
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      isScrolled: false,
      isDropdownShown: false,
      mobileMenuTitle: "Меню",
      links: [
      {
        title: "Головна",
        to: "main",
        visible: true,
      },
      {
        title: "Магазин",
        to: "subscription",
        visible: true,
      },
      {
        title: "Інформація",
        visible: true,
        dropdown: [
          {
            title: "Поточний сезон",
            to: "season"
          },
          {
            title: "Історія OMHMS",
            to: "history"
          },
          {
            title: "База знань 🔗",
            href: "https://omhms.notion.site/OMHMS-1c93cbc107f84fc8b80172b3224ba48b",
            // visible: true,
          },
          // {
          //   title: "Основне про OMHMS",
          //   to: "about"
          // },
          // {
          //   title: "Правила",
          //   to: "rules"
          // },
          {
            title: "Правила 🔗",
            href: "https://omhms.notion.site/bb231f80a6e247d5b03c36295ac68846",
            visible: true,
          },
          {
            title: "Сувенірка і мерч",
            to: "Merch"
          },
          {
            title: "OMHMS медіа-кіт",
            to: "Media"
          },
          {
            title: "Модпак від одмєна",
            to: "Modpack"
          }
        ]
      },
      {
        title: "Карта",
        href: "https://omhms.com:10000",
        visible: true,
      },
      {
        title: "Адмінськє",
        // visible: true,
        can: "admin",
        dropdown: [
          {
            title: "Статистика",
            to: "stats",
          },
          {
            title: "Гравці",
            to: "players",
          },
          {
            title: "RCON",
            to: "rcon",
          },
          {
            title: "PHPMyAdmin",
            href: "http://omhms.com:322/phpmyadmin/",
          }
        ]
      }, 
      ],
      showOfflineBlock: false,
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      check: "auth/check",
      profile: "profile/profile"
    }),

    filteredLinks() {
      return this.links.filter(l => this.isLinkVisible(l))
    },

    // profileLinkMenuTitle() {
    //   return `Особистий кабінет${ (this.user && this.user.realName) ? ` (${this.user.realName})` : "" }`
    // },

    isClear() {
      if (!this.$route) return true
      if (this.isScrolled) return false
      return this.$route.name === 'main' || this.$route.name === 'games' || this.$route.name === 'notFound'
    },

  },
  created() {
    window.addEventListener('scroll', this.handleScroll);

    ifUrlExist(process.env.VUE_APP_MAIN_FRONT_ENDPOINT, (exists) => {
      this.showOfflineBlock = !exists
    });
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    isLinkVisible(link) {
      if (link.can) { return this.$can(link.can) }
      if (link.registrationApproved) { return this.user.registrationStatus === "approved" }
      return link.visible
    },

    showDropdownMenu(value) {
      this.isDropdownShown = value
    },

    hideDropdownMenu() {
      this.isDropdownShown = false
    },

    handleScroll () {
      if (this.$route.name === 'notFound') {
        return
      }
      this.isScrolled = window.scrollY > 5
    }
  }
}
</script>
